import React from 'react';

import { useSetupAnalyticsClient, useSetupApolloClient } from '@atlassian/ptc-common';
import { setEnv } from '@atlassian/teams-common/context-config';

import App from './components/App';
import { type EmbeddableDirectoryProps } from './types';

const EmbeddableDirectory = (props: EmbeddableDirectoryProps) => {
	const {
		addFlag,
		appName,
		contextSpaPaths,
		contextEntryPoint,
		locale,
		push,
		replace,
		docTitle,
		statusCodeHandlers,
		env,
		history,
		isSentryEnabled = true,
		cloudId,
		orgId,
		teamCentralHandlers,
		subProduct,
		productFeatureFlags,
		invitePeopleHandlers,
		isAIEnabled,
	} = props;

	if (env) {
		setEnv(env);
	}

	const analyticsClient = useSetupAnalyticsClient(cloudId, appName, subProduct);
	const apolloClient = useSetupApolloClient(cloudId);

	if (!analyticsClient) {
		return null;
	}

	return (
		<App
			apolloClient={apolloClient}
			analytics={analyticsClient}
			appName={appName}
			contextSpaPaths={contextSpaPaths}
			contextEntryPoint={contextEntryPoint}
			env={env}
			push={push}
			replace={replace}
			addFlag={addFlag}
			locale={locale}
			docTitle={docTitle}
			statusCodeHandlers={statusCodeHandlers}
			history={history}
			cloudId={cloudId}
			orgId={orgId}
			teamCentralHandlers={teamCentralHandlers}
			skipI18nProvider={false}
			productFeatureFlags={productFeatureFlags}
			invitePeopleHandlers={invitePeopleHandlers}
			isSentryEnabled={isSentryEnabled}
			isAIEnabled={isAIEnabled}
		/>
	);
};

export default EmbeddableDirectory;

export type { EmbeddableDirectoryProps } from './types';
export { useCollaboratorsQuery } from './components/Collaborators';
export type { DirectoryInvitePeopleSource } from './components/AppConfigContext/types';
